/**
 * The rail's item grammar (ADR 0029 §3). The sidebar primitive sets the
 * radius, type, and hover; this adds the compact control height, which the
 * foundation token already lifts to 44 px on a coarse pointer, the current
 * item's lift onto the tile surface with a hairline, and the shell's short
 * colour motion.
 */
export const RAIL_LIFT =
  "border border-transparent transition-[color,background-color,border-color,width,height,padding] duration-[var(--motion-fast)] ease-[var(--ease-standard)] data-[active=true]:border-border data-[active=true]:bg-card data-[active=true]:text-foreground data-[active=true]:hover:bg-card";

export const RAIL_ITEM = `h-auto min-h-[var(--control-height-compact)] ${RAIL_LIFT}`;
